export default {
  payWelfareText: 'Benefici Ricarica',
  blackFridayDiscount: 'Sconto a Tempo Black Friday',
  shareGift: 'Condividi Regalo',
  vipWeeklyWelfare: 'Sconto Settimanale VIP',
  exchangeCoupon: 'Buono',
  firstPayOff: 'Fino al 15% di SCONTO per il Primo Acquisto',
  blackFridayEvent: 'Evento Black Friday',
  limitedTimeOff: 'Sconto del 10% per un Periodo Limitato',
  claimCoupon: 'Rivendica Ora',
  blackFridayTimedCoupon: 'Buono a Tempo Black Friday',
  timeLeft: 'Tempo restante:',
  claimTimeCoupon: 'Rivendica Buono 10% SCONTO Ora!',
  points: 'Punti: ${point}',
  costPointTip: 'Scambia punti per buoni',
  maxPointTip: 'Ogni account può usare fino a 500 punti.',
  discountOff: '10% SCONTO',
  highestDiscount: 'Fino a ${discount} SCONTATI',
  needPoint: 'Richiede ${point} pti',
  changeCurrency: 'Cambia Valuta',
  claim: 'Rivendica',
  claimSucc: 'Rivendicato',
  claimFail: 'Fallito',
  pointNotEnough: 'Pti insufficienti',
  afterClaimPoint: 'Punti rimanenti: ${point}',
  footTips1: 'È possibile utilizzare solo 1 buono per ogni ordine.',
  footTips2:
    'Il buono non può essere utilizzato per acquistare valute/gettoni di gioco.',
  footTips3:
    "Ci riserviamo il diritto per l'interpretazione finale di questo evento.",
  ruleTitleText: 'Regole Evento',
  ruleTime:
    "Durata dell'Evento: 00:00 del 24 Nov. 2023 alle 23:59 del 26 Nov. 2023 (UTC)",
  bfRuleText1:
    "1. 400 punti verranno assegnati al tuo account quando accedi per la prima volta alla pagina di ricarica ufficiale durante l'evento. Puoi scambiare fino a 500 punti con buoni.",
  bfRuleText2:
    "2. Puoi scambiare i punti del Black Friday con i buoni durante l'evento.",
  bfRuleText3:
    '3. Puoi utilizzare solo 1 buono per ogni ordine. I buoni non possono essere utilizzati per acquistare valute/gettoni di gioco.',
  bfRuleText4: '4. Per le transazioni accettiamo solo le seguenti valute:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Non è possibile cambiare la valuta una volta effettuata la transazione. I punti scambiati non possono essere rimborsati.',
  bfRuleText6: '6. I buoni del Black Friday saranno validi solo per 7 giorni.',
  bfRuleText7:
    "7. Ci riserviamo il diritto per l'interpretazione finale di questo evento.",
  thanksTip:
    "Grazie per la vostra partecipazione. Unisciti alla nostra community ufficiale per ulteriori informazioni sull'evento.",
  exchangePoints: 'Scambio',
  exchangeCode: 'Inserisci il codice di scambio.',
  enterExchangeCode: 'Inserisci il codice di scambio.',
  exchangeText: 'Scambio',
  confirmGet: 'Conferma',
  couponUsedWay:
    'Il buono può essere utilizzato solo con valute specifiche, conferma la tua valuta.',
  confirmText: 'Conferma',
  exchangeSucc: 'Scambiato',
  aboutCoins: 'Informazioni su Valute/Gettoni di gioco',
  aboutCoinsText:
    'Puoi scambiare valute/gettoni di gioco con tutti i pacchetti e privilegi ad eccezione della valuta/gettone di gioco stesso.',
  known: 'OK',
  codeText: 'Codice',
  codeInvalid: 'Codice invalido!',
  hasExchanged: 'Non puoi richiedere più codici.',
  hideText: 'Nascondi',
  //黑五的报错码
  'bf-20001': 'Accesso non effettuato',
  'bf-20002': "Errore di parametro. Prova a rientrare nell'evento.",
  'bf-20003': 'Pti insufficienti',
  'bf-20004': "Fallito! Riprova più tardi o contatta l'Assistenza Clienti.",
  'bf-20005': 'Rivendicato',
  'bf-20015': 'L’evento non è al momento disponibile',
  'bf-20016': 'L’evento è terminato.',
  bfShareText: 'Rivendica Buono 10% SCONTO Ora!',
  rightsCenterBtn: 'Centro Membro Premium',
  payBtn: 'Pagamento',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorioso Straordinario (Permanente)',
  rightCenterNoticeTitle: 'Il Sistema Punto VIP si Aggiorna al Centro Privilegi',
  rightCenterNoticeContent: "Saluti, Comandante!<br />Grazie per il vostro continuo sostegno. Per offrirvi un'esperienza di ricompensa ancora migliore, il 26 giugno 2025 l'attuale sistema Punto VIP sarà aggiornato con il nuovissimo Centro Privilegi. Questo nuovo sistema non solo consoliderà i benefici VIP esistenti, ma introdurrà anche una serie di nuovi ed entusiasmanti benefici. Ecco cosa c'è da sapere:<br />1. Cosa sta Cambiando?<br />I Benefici dell'Accesso Settimanale Rimangono<br />Dal 26 giugno al 9 luglio 2025, i giocatori potranno continuare a richiedere i Buoni VIP Settimanali collegandosi alla Pagina di Ricarica Ufficiale. Il numero di buoni rimarrà lo stesso dell'evento Punto VIP. Nel frattempo, i giocatori potranno anche richiedere nuovi buoni nel Centro Privilegi, che includeranno un tetto massimo di sconti. Per tutti i dettagli sulle nuove regole dei buoni e sui limiti di riscatto, consultare la tabella alla fine di questo avviso.<br />Nota: La funzione di riscossione automatica dei buoni deve essere attivata manualmente. Per farlo, andare su: Homepage Centro Privilegi > Benefici Membri > Abilita Riscatto Automatico Buoni > Seleziona Buoni da Riscattare Automaticamente > Conferma.<br />Nuova Funzione Scambio Punti<br />Il Centro Privilegi offrirà una funzione di Scambio Punti. Guadagna punti accedendo al gioco o completando le attività designate, poi scambiali con buoni esclusivi, oggetti rari e altre ricompense di valore. (Consulta la pagina del Centro Privilegi per i limiti di riscatto degli oggetti.)<br />Migrazione Livello VIP<br />Il vostro attuale livello VIP e i Punti VIP accumulati saranno completamente trasferiti al nuovo sistema. Vi verrà assegnato automaticamente il livello corrispondente del Centro Privilegi e tutti i vostri attuali benefici VIP saranno mantenuti e addirittura migliorati.<br />2. Perché Questo Aggiornamento è Migliore<br />Benefici Più Chiari: Tutte le regole delle ricompense e i dettagli di riscatto sono visualizzati in modo chiaro, rendendo più facile che mai richiedere i tuoi benefici.<br />Ricompense più Grandi: Godetevi nuovi eventi di scambio punti e oggetti di alto valore aggiornati regolarmente.<br />Estrazioni Fortunate: Oltre allo scambio di punti, saranno disponibili anche eventi di estrazione fortunata che daranno la possibilità di vincere preziosi oggetti di gioco.<br />3. Note Importanti<br />Durante il periodo di transizione (26 giugno - 9 luglio 2025), la sezione originale dei Punti VIP sarà gradualmente eliminata. Durante questo periodo sarà comunque possibile ricevere e usare i buoni come di consueto. Assicuratevi di usare tutti i buoni rimasti prima della fine dell'Evento Punti VIP: I buoni non usati scadranno una volta chiuso.<br />Quando il Centro Privilegi sarà attivo, potrete accedervi andando su: Centro di Ricarica Ufficiale > Tocca il tuo Avatar > Centro Privilegi",
  rightCenterNoticeTableTitle: 'Confronto delle modifiche ai coupon',
  rightCenterNoticeTableHeader1: 'Requisiti per il Riscatto - Membro Livello Premium',
  rightCenterNoticeTableHeader2: 'Livello VIP originale',
  rightCenterNoticeTableHeader3: 'Sconto Buono',
  rightCenterNoticeTableHeader4: 'Limite di Acquisizione',
  rightCenterNoticeTableHeader5: 'Limite Sconto Massimo',
  rightCenterNoticeTableLevel1: 'Bronzo',
  rightCenterNoticeTableLevel2: 'Argento',
  rightCenterNoticeTableLevel3: 'Oro', 
  rightCenterNoticeTableLevel4: 'Platino',
  rightCenterNoticeTableLevel5: 'Diamante',
  rightCenterNoticeTableCount1: 'Una Volta al Giorno',
  rightCenterNoticeTableCount2: '15 Volte/Mese',
  rightCenterNoticeTableCount3: '10 Volte/Mese',
  rightCenterNoticeTableLimit: '$15',
  rightCenterNoticeTableTip: 'Nota: I massimali di sconto dei buoni nel Centro Privilegi si basano su USD e possono variare in base ai tassi di cambio. L\'importo effettivo dello sconto viene visualizzato nella pagina di utilizzo.',
  '-': '-'
};
